import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appWizardItem]'
})
export class WizardItemDirective {

  constructor( public tpl: TemplateRef<any> ) { }

}
